/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetHlsLivePlaylistQueryResponse, SegmentsGetHlsLivePlaylistPathParams, SegmentsGetHlsLivePlaylistQueryParams, SegmentsGetHlsLivePlaylist400, SegmentsGetHlsLivePlaylist401, SegmentsGetHlsLivePlaylist403, SegmentsGetHlsLivePlaylist404 } from "../models/SegmentsGetHlsLivePlaylist";

export function getSegmentsGetHlsLivePlaylistUrl(station: SegmentsGetHlsLivePlaylistPathParams["station"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/hls-live` as const }
  return res
}

/**
 * @description Returns an HLS media playlist (M3U8) for a rolling live window ending at the latest available segments. Window size and byte-range behavior are controlled via query parameters.
 * @summary Get continuous live HLS playlist
 * {@link /segments/v1/stations/:station/hls-live}
 */
export async function segmentsGetHlsLivePlaylist(station: SegmentsGetHlsLivePlaylistPathParams["station"], params?: SegmentsGetHlsLivePlaylistQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetHlsLivePlaylistQueryResponse, ResponseErrorConfig<SegmentsGetHlsLivePlaylist400 | SegmentsGetHlsLivePlaylist401 | SegmentsGetHlsLivePlaylist403 | SegmentsGetHlsLivePlaylist404>, unknown>({ method : "GET", url : getSegmentsGetHlsLivePlaylistUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}